import { Router, Request, Response } from '../utils/Router'
import * as array from '../utils/array'
import { getLocaleFromUrl } from '../i18n/I18n'
import { parseHash } from '../utils/URL'
import { setupCDPSimple } from '../utils/cdpsimple'

import { Dialog } from '../components/flipp-dialog/Dialog'
import { ErrorPage } from '../components/flipp-error-page/ErrorPage'
import { NewLandingPage } from '../components/flipp-new-landing-page/NewLandingPage'
import { SigninPage } from '../components/flipp-login/SigninPage'
import { SignupPage } from '../components/flipp-login/SignupPage'
import { ForgotPasswordPage } from '../components/flipp-login/ForgotPasswordPage'
import { ConfirmEmailPage } from '../components/flipp-login/ConfirmEmailPage'
import { ConfirmChangePasswordPage } from '../components/flipp-login/ConfirmChangePasswordPage'
import { ChangePasswordPage } from '../components/flipp-login/ChangePasswordPage'
import { OptInPage } from '../components/flipp-login/OptInPage'
import { FavouritesPage } from '../components/flipp-favourites-page/FavouritesPage'
import { NativeLanding } from '../components/flipp-native-landing/NativeLanding'
import { ActionLanding } from '../components/flipp-action-landing/ActionLanding'
import { SearchPage } from '../components/flipp-search-page/SearchPage'
import { CouponsPageEntry } from '../components/flipp-coupons-page/CouponsPageEntry'
import { FlyerPage } from '../components/flipp-flyer-page/FlyerPage'
import { ShoppingListEntry } from '../components/flipp-shopping-list/ShoppingListEntry'

import { FlyerCategory } from '../definitions/FlyerDefinitions'
import { DisplayType } from '../definitions/ApiDefinitions'
import { Coupon } from '../definitions/CouponDefinitions'

import { StorageService } from '../services/StorageService'
import { SeoService, CityJSON } from '../services/SeoService'
import {
    LocationService,
    PostalCode,
    LocationInfo,
    Country,
} from '../services/LocationService'
import { FlyerService } from '../services/FlyerService'
import { CouponService } from '../services/CouponService'
import { FavouriteService } from '../services/FavouriteService'
import { BlacklistService } from '../services/BlacklistService'
import { LinkService } from '../services/LinkService'
import {
    ConfigService,
    RuntimeConfig,
    Experience,
} from '../services/ConfigService'
import { SearchService } from '../services/SearchService'
import { AnalyticsService } from '../services/AnalyticsService'
import { UserAgentService } from '../services/UserAgentService'
import { AuthenticationService } from '../services/AuthenticationService'
import {
    AuthStatus,
    LoginState,
} from '../services/definitions/IAuthenticationService'
import { HistoryService } from '../services/HistoryService'
import {
    CouponActions,
    CouponSource,
    SourceAction,
} from '../services/definitions/IAnalyticsService'
import MetadataService from '../services/MetadataService'
import MetaTitleAndDescService from '../services/MetaTitleAndDescService'
import { FlyersViewedService } from '../services/FlyersViewedService'
import { ExpiredCanonicalsService } from '../services/ExpiredCanonicalsService'
import { ExpiredMetadaService } from '../services/ExpiredMetadaService'
import { ModalService } from '../services/ModalService'
import { EventService } from '../services/EventService'
import { CityHomepage } from '../components/flipp-city-homepage/CityHomepage'
import { SeoDataService } from '../services/SeoDataService'
import { AppRatingService } from '../services/AppRatingService'
import {
    makeCouponPop,
    renderDeleteAccountModal,
    makeItemPop,
} from '../utils/modal'
import { DateTimeService } from '../services/DateTimeService'
import { CCPAForm } from '../components/flipp-data-form/CCPAForm'
import { CCPAFormSuccess } from '../components/flipp-data-form/CCPAFormSuccess'
import { CategoryService } from '../services/CategoryService'
import { BlackFridayService } from '../services/BlackFridayService'
import { SessionStorageService } from '../services/SessionStorageService'
import { AppsFlyerService } from '../services/AppsFlyerService'
import { StoresPage } from '../components/flipp-stores-page/StoresPage'
import { FlyersCountry } from '../components/flipp-flyers-country/FlyersCountry'
import { CityStorePage } from '../components/flipp-city-store-page/CityStorePage'
import { StoreCityFlyers } from '../components/store-city-flyers/StoreCityFlyers'
import { ListingPage } from '../components/flipp-listing-page/ListingPage'
import { GPCService } from '../services/GPCService'
import { CookieyesService } from '../services/CookieyesService'
import { DatadogRumService } from '../services/DatadogRUMService'
import { ShoppingListService } from '../services/ShoppingListService'
import { AdAdaptedService } from '../services/AdAdaptedService'
import { sanitize } from '../utils/sanitize'
const storageService = StorageService.getInstance()
const locationService = LocationService.getInstance()
const flyerService = FlyerService.getInstance() as FlyerService
const couponService = CouponService.getInstance() as CouponService
const favourites = FavouriteService.getInstance() as FavouriteService
const linkService = LinkService.getInstance()
const config = ConfigService.getInstance()
const searchService = SearchService.getInstance() as SearchService
const analytics = AnalyticsService.getInstance()
const authService = AuthenticationService.getInstance()
const historyService = HistoryService.getInstance()
const userAgentService = UserAgentService.getInstance()
const blacklistService = BlacklistService.getInstance() as BlacklistService
const metadataService = MetadataService.getInstance()
const metaTitleAndDescService = MetaTitleAndDescService.getInstance()
const expiredCanonicalsService = ExpiredCanonicalsService.getInstance()
const seoService = SeoService.getInstance()
const seoDataService = SeoDataService.getInstance()
const dateTimeService = DateTimeService.getInstance()
const modalService = ModalService.getInstance()
const appRatingService = AppRatingService.getInstance()
const eventService = EventService.getInstance()
const appsflyerService = AppsFlyerService.getInstance()
const gpcService = GPCService.getInstance()
const cookieyesService = CookieyesService.getInstance()
const datadogRumService = DatadogRumService.getInstance()

// Define router
export const router = new Router()

// custom transitions for coupon and item
let itemOrCouponDialog: Dialog = null
function back() {
    historyService.doBack()
}

function couponCloseForward() {
    linkService.execute('/coupons', window)
}

const EXP_ESCAPE_ROUTES = [
    '/',
    '/flyers',
    '/weekly_ads',
    '/circulaires',
    '/search',
    '/recherche',
    '/shopping_list',
    '/liste_dachats',
]

// Public Definitions -------------------------------------------------------->

router
    .addRoute('/:locale/home')
    .addRoute('/:locale/accueil')
    .addRoute('/en-ca/flyers-canada')
    .addRoute('/en-us/flyers-usa')
    .addRoute('/:locale/store-city-flyers')
    .addRoute('/store-city-flyers')
    .addRoute('/signin')
    .addRoute('/:locale/signin')
    .addRoute('/signup')
    .addRoute('/:locale/signup')
    .addRoute('/forgot_password')
    .addRoute('/:locale/forgot_password')
    .addRoute('/confirm_email')
    .addRoute('/:locale/confirm_email')
    .addRoute('/confirm_change_password')
    .addRoute('/:locale/confirm_change_password')
    .addRoute('/change_password')
    .addRoute('/:locale/change_password')
    .addRoute('/opt_in')
    .addRoute('/:locale/opt_in')
    .addRoute('/flyers')
    .addRoute('/:locale/flyers')
    .addRoute('/flyers/:category')
    .addRoute('/:locale/flyers/:category')
    .addRoute('/:locale/:city/flyers')
    .addRoute('/:locale/:city/flyers/:category')

    .addRoute('/weekly_ads')
    .addRoute('/weekly_ads/:category')
    .addRoute('/:locale/:city/weekly_ads')
    .addRoute('/:locale/:city/weekly_ads/:category')

    .addRoute('/circulaires')
    .addRoute('/circulaires/:category')
    .addRoute('/:locale/circulaires/:category')
    .addRoute('/:locale/:city/circulaires')
    .addRoute('/:locale/:city/circulaires/:category')

    .addRoute('/:locale/:city/coupons')
    .addRoute('/:locale/:city/coupons/:category')

    .addRoute('/:locale/coupon/:slug')
    .addRoute('/coupon/:slug')
    .addRoute('/:locale/:city/coupon/:slug')

    .addRoute('/search')
    .addRoute('/search/:query')
    .addRoute('/search/:city/:query')
    .addRoute('/search/:city/:query/:sort')
    .addRoute('/:locale/search/:query')
    .addRoute('/:locale/search/:city/:query')
    .addRoute('/:locale/search/:city/:query/:sort')

    .addRoute('/recherche')
    .addRoute('/recherche/:query')
    .addRoute('/recherche/:city/:query')
    .addRoute('/recherche/:city/:query/:sort')
    .addRoute('/:locale/recherche/:query')
    .addRoute('/:locale/recherche/:city/:query')
    .addRoute('/:locale/recherche/:city/:query/:sort')

    .addRoute('/:city/flyer/:slug')
    .addRoute('/:city/weekly_ad/:slug')
    .addRoute('/:city/circulaire/:slug')
    .addRoute('/:locale/:city/flyer/:slug')
    .addRoute('/:locale/:city/weekly_ad/:slug')
    .addRoute('/:locale/:city/circulaire/:slug')

    .addRoute('/item/:slug')
    .addRoute('/:locale/item/:slug')
    .addRoute('/:locale/:city/item/:slug')

    .addRoute('/produit/:slug')
    .addRoute('/:locale/produit/:slug')
    .addRoute('/:locale/:city/produit/:slug')

    .addRoute('/en-us/:city')
    .addRoute('/en-ca/:city')
    .addRoute('/fr-ca/:city')

    .addRoute('/:locale/store/:storename')

    .addRoute('/:locale/stores')
    .addRoute('/:locale/:city/stores/:store')
    .addRoute('/:locale/:city/stores')

    .addRoute('/:locale/categories')
    .addRoute('/:locale/categories/:category')
    .addRoute('/:locale/categories/:category/:sub_category')

    .addRoute('/:locale/products/:product_name/browser')
    .addRoute('/:locale/products/:product_name/browser/:state')

    .addRoute('/:locale/browser')
    .addRoute('/:locale/browser')
    .addRoute('/:locale/browser/:state')

    .addRoute('/:locale/browser/:state/categories')
    .addRoute('/:locale/browser/:state/categories/:category')
    .addRoute('/:locale/browser/:state/categories/:category/:sub_category')

    .addRoute('/blackfriday')
    .addRoute('/blackfriday/:locale')
    .addRoute('/data-deletion')

    .use(async (req, res, next) => {
        /* This is awkward, but we don't know the runtime behaviour until the first request. Requests from
         * native distribution will come in on the /dist route, otherwise we can assume it's the default
         * behaviour. The assumption here is that native distribution will ALWAYS drive to the /dist path
         * FIRST. */

        if (!analytics.isInitialized() && req.path === '/login_redirect') {
            /* Don't configure analytics if the first request is a login redirect. This can only be the case
             * for the fallback OAuth flow for IE11 where we are using full page transitions instead of
             * postMessage between windows. */
            return next()
        } else if (analytics.isInitialized()) {
            /* If the runtime is Distribution, we need to check for the user transitioning out of
             * the flyer view (eg: clicking the Flipp logo to go to the flyer listing). Once this
             * occurs, we break out of the 'distribution experience' (with embedded SL, x-browse
             * section, etc) and render the site as normal (with left nav, etc)
             * TODO: explore whether this is possible to add custom transitions in the router
             */
            if (
                config.RUNTIME === RuntimeConfig.DISTRIBUTION &&
                EXP_ESCAPE_ROUTES.indexOf(req.path) !== -1
            ) {
                config.EXPERIENCE = Experience.DEFAULT
                document.documentElement.removeAttribute('experience')
            }
            return next()
        }

        const isNativeReq = req.path === '/dist'
        /*
				Save the properties required for the circular destination service
			*/
        // True if route is not /dist but we want to show the distribution experience
        const forceNativeExperience = setupCDPSimple(isNativeReq, req)
        config.RUNTIME =
            isNativeReq || forceNativeExperience
                ? RuntimeConfig.DISTRIBUTION
                : RuntimeConfig.DEFAULT
        config.EXPERIENCE =
            isNativeReq || forceNativeExperience
                ? Experience.DISTRIBUTION
                : Experience.DEFAULT
        const sessionStorageService = SessionStorageService.getInstance()
        const isSde = sessionStorageService.getItem('sde')
        const isInIframe = window !== window.parent
        if (
            ((isSde || req.params['sde'] === 'true') && isInIframe) ||
            req.params['force_sde'] === 'true'
        ) {
            config.EXPERIENCE = Experience.SDE
            sessionStorageService.setItem('sde', 'true')
        }
        // Update merchant xbrowse configs
        config.updateXBrowse(req)

        if (config.isProduction()) {
            if (config.EXPERIENCE !== Experience.SDE && !window.Cypress) {
                cookieyesService.init()
            }
            datadogRumService.init()
        }
        analytics.init(config.RUNTIME)
        await appsflyerService.init()

        const flippUser = Cookies.get('flipp-user')
        Cookies.remove('flipp-user', {
            domain: config.ENV === 'development' ? 'localhost' : '.flipp.com',
        })

        const flippLogin = Cookies.get('flipp-login')
        Cookies.remove('flipp-login', {
            domain: config.ENV === 'development' ? 'localhost' : '.flipp.com',
        })

        if (flippUser && flippLogin) {
            Cookies.set('flipp-user', flippUser, {
                domain:
                    config.ENV === 'development' ? 'localhost' : '.flipp.com',
            })
            Cookies.set('flipp-login', flippLogin, {
                domain:
                    config.ENV === 'development' ? 'localhost' : '.flipp.com',
            })
        }

        if (isNativeReq && req.params['blacklist_merchant_ids']) {
            const blacklistedIds = req.params['blacklist_merchant_ids']
                .split(',')
                .map(Number)
            blacklistService.addBlacklistedMerchants(blacklistedIds)
        }

        /* Check if the params contain a 'context' param. If so, just redirect to the provided
         * URL after the runtime have been configured */
        if (isNativeReq && req.params['context']) {
            document.documentElement.setAttribute(
                'postalcode',
                req.params['fsa']
            )
            document.documentElement.setAttribute(
                'city',
                ''
            ) /* Is 'city' used anywhere in the native exp? */

            if (req.params['exp'] === 'native') {
                document.documentElement.setAttribute('experience', 'native')
            }
            res.redirect(req.params['context'])
            return
        } else if (isNativeReq) {
            const searchFsa = req.params['fsa']
            if (searchFsa && PostalCode.isValid(searchFsa)) {
                document.documentElement.setAttribute('postalcode', searchFsa)
                document.documentElement.setAttribute(
                    'city',
                    ''
                ) /* Is 'city' used anywhere in the native exp? */
            }
        }
        return next()
    })
    .use((req, res, next) => {
        if (config.RUNTIME === RuntimeConfig.DISTRIBUTION) {
            /* Don't use push state for Safari in distribution mode. See HistoryService for details */
            config.PUSHSTATE_SUPPORTED = !bowser.safari
        }
        return next()
    })
    .use((req, res, next) => {
        if (
            document.documentElement.hasAttribute('postalcode') &&
            document.documentElement.hasAttribute('city')
        ) {
            return next()
        }

        const infoPromise: Promise<LocationInfo> =
            'postal_code' in req.params
                ? locationService.savePostalCode(
                      new PostalCode(req.params['postal_code'])
                  )
                : locationService.getLocationInfo()

        return infoPromise
            .then((info) => {
                // TODO this won't work for isomorphic...
                document.documentElement.setAttribute(
                    'postalcode',
                    info.postal_code
                )
                document.documentElement.setAttribute('city', info.city_name)
                req.locationInfo = { ...info }
            })
            .then(next)
    })
    .use(async (req, res, next) => {
        // If it's
        // Check if we need to re-center the postal_code for SEO purposes.
        // If we have a :city parameter - and the current postal code is NOT
        // inside the list of that cities postal codes, then re-center the user
        // to match the city fallback UNLESS there is an explicit postal_code
        // already set - so we shouldn't obey the :city parameter.
        //
        // This is to allow us to give googlebot URLs that work in a city and they
        // can crawl correctly, but users don't get their postal_code preferences
        // trampled.

        // @todo remove hack for support legacy inCity parameter
        if (!('city' in req.params || 'in-city' in req.params)) {
            return next()
        }

        const inCity = req.params['city'] || req.params['in-city']
        if (inCity.length === 0 || inCity.indexOf('-') === -1) {
            return next()
        }

        const splittedInCity = inCity.split('-')
        const state = splittedInCity.pop()
        const city = splittedInCity.join('_')

        try {
            seoService.inCity = inCity
            if ('postal_code' in req.params) {
                return next()
            }
            if (
                req.locationInfo &&
                req.locationInfo.city_name === city.replace('_', ' ')
            ) {
                await locationService.savePostalCode(
                    new PostalCode(req.locationInfo.postal_code)
                )
                return next()
            }

            const cityJSON: CityJSON = await seoService.getCityInfo(state, city)

            if (
                !cityJSON ||
                (cityJSON &&
                    (!cityJSON.geo_codes || cityJSON.geo_codes.length === 0))
            ) {
                return next()
            }

            // If we are NOT in the current city, the we need to re-center.
            if (cityJSON.geo_codes.indexOf(locationService.geoCode) === -1) {
                const info: LocationInfo = await locationService.savePostalCode(
                    new PostalCode(cityJSON.fallback_postal_code)
                )
                req.locationInfo = info

                // TODO this won't work for isomorphic...
                document.documentElement.setAttribute(
                    'postalcode',
                    info.postal_code
                )
                document.documentElement.setAttribute('city', info.city_name)
            }
        } catch (e) {
            console.log(e)
        }

        return next()
    })

    // locale and location are not necessarily related!
    .use(async (req, res, next) => {
        if (seoService.hasLocale()) {
            return next()
        }

        const getLocale = async () => {
            if (getLocaleFromUrl()) {
                return getLocaleFromUrl()
            } else if ('locale' in req.params) {
                return req.params['locale']
            } else if (storageService.getItem('locale')) {
                const locale = storageService.getItem('locale')

                /* Check to ensure the saved locale is consistent with the postalcode. If it's not,
                 * don't use the saved version and instead fall back */
                const code = document.documentElement.getAttribute('postalcode')
                const postalCode = new PostalCode(code)
                if (
                    postalCode.country === Country.CANADA &&
                    (locale === 'en-ca' || locale === 'fr-ca')
                ) {
                    return locale
                } else if (
                    postalCode.country === Country.USA &&
                    locale === 'en-us'
                ) {
                    return locale
                }
            }
            // FIXME [FW-77] Backflipp should be *the* definitive source for
            // locale, by using `Accept-Language`
            const info: LocationInfo = await locationService.getLocationInfo()
            const countryCode = info.country_code_by_postal_code
                ? info.country_code_by_postal_code
                : info.country_code_by_ip
            if (countryCode.toLowerCase() !== 'ca') {
                return 'en-us'
            }

            return info.region_name === 'QC' ? 'fr-ca' : 'en-ca'
        }

        let locale = await getLocale()
        locale = seoService.fixTrailingSlash(locale)
        seoService.setLocale(locale)

        return next()
    })

    .use((req, res, next) => {
        // has postal code & locale
        const postalCode = document.documentElement.getAttribute('postalcode')
        const locale = seoService.locale

        analytics.setPostalCode(postalCode)
        analytics.setLocale(locale)

        return next()
    })

    .use((req, res, next) => {
        metadataService.removeCanonicalLink(req.params)
        return next()
    })
    .use((req, res, next) => {
        // Init the auth service
        return authService.init().then(() => {
            /* After initialization, set account guid on analytics if user is logged in. It's slightly
             * hackish to do it here, but AnalyticsService cannot have a dependency on AuthenticationService
             * directly */
            if (authService.status === AuthStatus.LOGGED_IN) {
                analytics.setAccountGuid(authService.user.token.user_id)
            }
            if (!req.path.includes('/privacy-choices')) {
                gpcService.init()
            }
            return next()
        })
    })

    .use((req, res, next) => {
        // Theme color update
        config.updateThemeColor(req)

        return next()
    })
    .use(async (req, res, next) => {
        const promises = [
            seoDataService.fetchCanadianProvinces(),
            seoDataService.fetchUsStates(),
            seoDataService.fetchCaCities(),
            seoDataService.fetchUsCities(),
            seoDataService.fetchCaMerchants(),
            seoDataService.fetchUsMerchants(),
        ]
        metadataService.setReqParamsQuery(req.params)

        if (userAgentService.mobile) {
            promises.push(appRatingService.fetchAppRating())
        }
        await Promise.all(promises)

        await metadataService.canonicalizeLocale()

        return next()
    })
    .use(async (req, res, next) => {
        const sessionID = storageService.getItem('session_id')
        if (sessionID) {
            Cookies.set('session_id', sessionID, { expires: 365 })
        }
        storageService.removeItem('session_id')

        const shoppingList = JSON.parse(
            storageService.getItem('shopping_list') || '{}'
        )
        if (shoppingList.users) {
            Cookies.set('users', JSON.stringify(shoppingList.users), {
                expires: 365,
            })
        }

        delete shoppingList.users
        storageService.setItem('shopping_list', JSON.stringify(shoppingList))

        return next()
    })
    .use((req, res, next) => {
        const sessionStorageService = SessionStorageService.getInstance()
        if (req.params.synd === 'smartnews') {
            const synd = sessionStorageService.getItem('synd')
            if (!synd) {
                sessionStorageService.setItem('synd', 'smartnews')
            }
        }
        return next()
    })
    // Declare the route paths
    // NOTE: this gives us flexibility on how we could set up the inverse:
    // given a target route name and locale generate the path...
    .route('/', 'index')
    .route('/home', 'home')
    .route('/en-ca/flyers-canada', 'flyers-country')
    .route('/fr-ca/flyers-canada', 'flyers-country')
    .route('/en-us/flyers-usa', 'flyers-country')
    .route('/:locale/store-city-flyers', 'store-city-flyers')
    .route('/:locale/store-city-weekly_ads', 'store-city-flyers')
    .route('/store-city-flyers', 'store-city-flyers')
    .route('/store-city-weekly_ads', 'store-city-flyers')
    .route('/signin', 'signin')
    .route('/:locale/signin', 'signin')
    .route('/signup', 'signup')
    .route('/:locale/signup', 'signup')
    .route('/forgot_password', 'forgot_password')
    .route('/:locale/forgot_password', 'forgot_password')
    .route('/confirm_email', 'confirm_email')
    .route('/:locale/confirm_email', 'confirm_email')
    .route('/confirm_change_password', 'confirm_change_password')
    .route('/:locale/confirm_change_password', 'confirm_change_password')
    .route('/change_password', 'change_password')
    .route('/:locale/change_password', 'change_password')
    .route('/opt_in', 'opt_in')
    .route('/:locale/opt_in', 'opt_in')

    .route('/search/:query', 'search')
    .route('/recherche/:query', 'search')

    .route('/:locale/home', 'home')
    .route('/accueil', 'home')
    .route('/:locale/accueil', 'home')

    .route('/en-us', 'country_homepage')
    .route('/en-ca', 'country_homepage')
    .route('/fr-ca', 'country_homepage')

    .route('/flyers', 'listing')
    .route('/flyers/:category', 'listing')
    .route('/:locale/flyers', 'listing')
    .route('/:locale/flyers/:category', 'listing')
    .route('/:locale/:city/flyers', 'listing')
    .route('/:locale/:city/flyers/:category', 'listing')

    .route('/weekly_ads', 'listing')
    .route('/weekly_ads/:category', 'listing')
    .route('/:locale/weekly_ads', 'listing')
    .route('/:locale/:city/weekly_ads', 'listing')
    .route('/:locale/weekly_ads/:category', 'listing')
    .route('/:locale/:city/weekly_ads/:category', 'listing')

    .route('/circulaires', 'listing')
    .route('/circulaires/:category', 'listing')
    .route('/:locale/circulaires', 'listing')
    .route('/:locale/circulaires/:category', 'listing')
    .route('/:locale/:city/circulaires', 'listing')
    .route('/:locale/:city/circulaires/:category', 'listing')
    .route('/:locale/circulaires/:category', 'listing')

    .route('/dist', 'distribution')

    .route('/:locale/stores', 'stores')
    .route('/:locale/:location/stores/:store', 'city_store')
    .route('/:locale/stores/:store', 'city_store')
    .route('/:locale/store/:store', 'city_store')
    .route('/:locale/:location/stores', 'stores')

    .route('/:locale/browser', 'states_browser')
    .route('/:locale/browser/:state', 'cities_browser')
    .route('/:locale/browser/:state/:city', 'categories')
    .route('/:locale/browser/:state/:city/:category', 'sub_categories')
    .route(
        '/:locale/browser/:state/:city/:category/:sub_category',
        'categories_products'
    )
    .route('/browser', 'states_browser')
    .route('/browser/:state', 'cities_browser')
    .route('/browser/:state/:city', 'categories')
    .route('/browser/:state/:city/:category', 'sub_categories')
    .route(
        '/browser/:state/:city/:category/:sub_category',
        'categories_products'
    )

    .route('/:locale/categories', 'categories')
    .route('/:locale/categories/:category', 'sub_categories')
    .route('/:locale/categories/:category/:sub_category', 'categories_products')
    .route('/categories', 'categories')
    .route('/categories/:category', 'sub_categories')
    .route('/categories/:category/:sub_category', 'categories_products')

    .route('/:locale/products/:product_name/browser', 'products')
    .route('/:locale/products/:product_name/browser/:state', 'products')
    .route('/products/:product_name/browser', 'products')
    .route('/products/:product_name/browser/:state', 'products')

    .route('/blackfriday', 'blackfriday')
    .route('/blackfriday/:locale', 'blackfriday')

    .route('/data-deletion', 'data-deletion')

    // Capture the old routes and redirect
    .route('/flyer', (req, res) => {
        const flyerId = parseInt(req.params['id'], 10)
        return flyerService.getFlyer(flyerId).then((flyer) => {
            if (!flyer) {
                res.redirect(linkService.linkTo('listing'))
            } else {
                res.redirect(linkService.linkTo(flyer), 301)
            }
        })
    })

    .route('/item', (req, res) => {
        const itemId = parseInt(req.params['id'], 10)
        return flyerService.getFlyerItem(itemId).then((item) => {
            if (!item) {
                res.redirect(linkService.linkTo('listing'))
            } else {
                res.redirect(linkService.linkTo(item), 301)
            }
        })
    })

    .route('/flyer_type', (req, res) => {
        const flyerTypeId = parseInt(req.params['id'], 10)
        return flyerService.getFlyers().then((flyers) => {
            const firstFlyer = array.find(
                flyers,
                (flyer) => flyer.flyerTypeId === flyerTypeId
            )

            if (firstFlyer) {
                res.redirect(linkService.linkTo(firstFlyer))
            } else {
                res.redirect(linkService.linkTo('listing'))
            }
        })
    })

    .route('/category', (req, res) => {
        const category = req.params['id']
        return flyerService.getFlyers().then((flyers) => {
            const firstFlyer = array.find(
                flyers,
                (flyer) => flyer.categories.indexOf(category) !== -1
            )

            if (firstFlyer) {
                res.redirect(linkService.linkTo(firstFlyer))
            } else {
                res.redirect(linkService.linkTo('listing'))
            }
        })
    })

    // Dispatch route
    .route('/share', dispatchFlyerOpen)
    .route('/action', (req, res, next) => {
        if (req.params['type'] === 'flyer_view') {
            return dispatchFlyerOpen(req, res)
        } else if (req.params['command'] === 'add_text_to_list') {
            const sl = ShoppingListService.getInstance()
            const text = sanitize(req.params['text'])
            const texts = sanitize(req.params['texts'])
            let itemsToReport: string[] = []
            if (text) {
                sl.addItemToShoppingList(text)
                itemsToReport = [text]
            } else if (texts) {
                const items = decodeURIComponent(texts).split(',')
                items.forEach((item) => {
                    const itemStr = item.trim()
                    if (itemStr) {
                        sl.addItemToShoppingList(itemStr)
                        itemsToReport.push(itemStr)
                    }
                })
            }
            const adAdapted = AdAdaptedService.getInstance()
            adAdapted.reportItemsAddedToList(itemsToReport, 'add_to_list_url')
            return dispatchShoppingList(req, res)
        } else if (req.params['type'] === 'shopping_list') {
            return dispatchShoppingList(req, res)
        } else if (
            req.params['type'] === 'coupons' ||
            req.params['type'] === 'loyalty_cards'
        ) {
            return dispatchCouponsListing(req, res)
        } else if (req.params['type'] === 'browse') {
            return dispatchFlyerListing(req, res)
        } else if (req.params['type'] === 'search') {
            return dispatchFlyerListing(req, res)
        } else if (
            req.params['type'] === 'brand_media' &&
            req.params['command'] === 'landing'
        ) {
            return dispatchBrandmediaLanding(req)
        }
        return next()
    })

    // A link used for redirection, for when postal code changes to get the
    // right localized url
    .route('/redirect', (req, res, next) => {
        /* If 'old_fsa' is included as a param to this route, it means that the
         * user has just changed their FSA. We want to send a beacon for this. */
        const oldFsa = req.params['old_fsa']
        if (oldFsa) {
            analytics.trackLocationChanges(oldFsa, locationService.postalCode)
        }

        const page = req.params['page']
        const bf = BlackFridayService.getInstance()
        if (bf.isOnHost()) {
            bf.redirectToHost()
        }
        if (!page) return next()
        const url = linkService.linkTo(page)
        if (!url) return next()
        res.redirect(url)
    })

    // Login redirect route for the fallback oauth case
    .route('/login_redirect', (req, res) => {
        const params = parseHash()
        if (bowser.msie && Number(bowser.version) <= 11) {
            /* IE 11 is a steaming pile and does not support postMessage across
             * tabs/windows opened using window.open. We need to use a fallback mechanism
             * using full page redirects */
            let redirect: string
            try {
                const state = JSON.parse(params['state']) as LoginState
                redirect = state.path
            } catch (e) {
                console.log(e)
            }
            res.redirect(redirect)
        } else {
            /* Pass the login info back to parent window to complete the login */
            window.opener.postMessage(
                {
                    type: 'auth-login',
                    result: 'success',
                    data: params,
                },
                req.url.origin
            )
            window.close()
        }
    })

    .route('/flyer/:slug', 'browse')
    .route('/weekly_ad/:slug', 'browse')
    .route('/circulaire/:slug', 'browse')

    .route('/:city/flyer/:slug', 'browse')
    .route('/:city/weekly_ad/:slug', 'browse')
    .route('/:city/circulaire/:slug', 'browse')
    .route('/:locale/:city/flyer/:slug', 'browse')
    .route('/:locale/:city/weekly_ad/:slug', 'browse')
    .route('/:locale/:city/circulaire/:slug', 'browse')

    .route('/item/:slug', 'item')
    .route('/:locale/item/:slug', 'item')
    .route('/:locale/:city/item/:slug', 'item')

    .route('/produit/:slug', 'item')
    .route('/:locale/produit/:slug', 'item')
    .route('/:locale/:city/produit/:slug', 'item')

    .route('/:locale/coupons', 'coupons')
    .route('/coupons', 'coupons')
    .route('/:locale/coupons/:category', 'coupons')
    .route('/coupons/:category', 'coupons')
    .route('/:locale/:city/coupons', 'coupons')
    .route('/:locale/:city/coupons/:category', 'coupons')

    .route('/:locale/coupon/:slug', 'coupon')
    .route('/coupon/:slug', 'coupon')
    .route('/:locale/:city/coupon/:slug', 'coupon')

    .route('/clippings', 'clippings')
    .route('/coupures', 'clippings')

    .route('/search', 'search')
    .route('/search/:city/:query', 'search')
    .route('/search/:city/:query/:sort', 'search')
    .route('/:locale/search/:query', 'search')
    .route('/:locale/search/:city/:query', 'search')
    .route('/:locale/search/:city/:query/:sort', 'search')

    .route('/recherche', 'search')
    .route('/recherche/:city/:query', 'search')
    .route('/recherche/:city/:query/:sort', 'search')
    .route('/:locale/recherche/:query', 'search')
    .route('/:locale/recherche/:city/:query', 'search')
    .route('/:locale/recherche/:city/:query/:sort', 'search')

    .route('/install', 'install')
    .route('/telechargez', 'install')

    .route('/shopping_list', 'shoppinglist')
    .route('/liste_dachats', 'shoppinglist')

    .route('/privacy-choices', 'ccpa_form')
    .route('/privacy-choices/success', 'ccpa_form_success')

    .route('/favourites', 'favourites')
    .route('/favorites', 'favourites')
    .route('/favoris', 'favourites')

    .route('/playstore', 'playstore')
    .route('/appstore', 'appstore')

    .route('/en-us/:city', 'city_homepage')
    .route('/en-ca/:city', 'city_homepage')
    .route('/fr-ca/:city', 'city_homepage')
    .route('/:city', 'city_homepage')

    // Default 404 handler
    .use((req, res) => {
        const isWatchList = req.params['type'] === 'watchlist'
        if (isWatchList) {
            metaTitleAndDescService.setWatchlist(res)
        } else {
            res.status = 404
            metaTitleAndDescService.setNotFound(res)
        }
        res.render(
            <ErrorPage page={true} isWatchList={isWatchList.toString()} />
        ).then(() => {
            analytics.trackPageNotFoundEvent()
        })
    })

// .route(500, (req, res) => {

// })

const routingToCoupon = (req: Request, res: Response) => {
    const couponId = parseInt(req.params['slug'].split('-')[0], 10)
    return couponService.getCoupon(couponId).then((coupon) => {
        setCouponTitleAndDescription(coupon, res)

        analytics.trackCoupon(
            coupon,
            CouponActions.Open,
            CouponSource.CouponListing
        )
        itemOrCouponDialog = makeCouponPop(coupon)
        itemOrCouponDialog.showModal()

        itemOrCouponDialog.addEventListener('close', back)
        itemOrCouponDialog.addEventListener('flipp-navigate', () => {
            itemOrCouponDialog.removeEventListener('close', back)
            itemOrCouponDialog.close()
        })
    })
}

const routingFromCoupon = (req: Request, res: Response) => {
    // close the dialog
    itemOrCouponDialog.removeEventListener('close', back)
    itemOrCouponDialog.removeEventListener('close', couponCloseForward)
    itemOrCouponDialog.addEventListener('flipp-navigate', () => {
        itemOrCouponDialog.removeEventListener('close', couponCloseForward)
        itemOrCouponDialog.removeEventListener('close', back)
        itemOrCouponDialog.close()
    })
    if (itemOrCouponDialog.open) itemOrCouponDialog.close()

    metaTitleAndDescService.setCoupon(req, res)
}

// Coupon pop routes
router
    .route(
        {
            from: 'coupons',
            to: 'coupon',
        },
        routingToCoupon
    )
    .route(
        {
            from: 'coupon',
            to: 'coupons',
        },
        routingFromCoupon
    )
    .route(
        {
            from: 'city_homepage',
            to: 'coupon',
        },
        routingToCoupon
    )
    .route(
        {
            from: 'coupon',
            to: 'city_homepage',
        },
        routingFromCoupon
    )

    // Item pop routes
    .route(
        {
            from: 'browse',
            to: 'item',
        },
        (req, res, next) => {
            const itemId = parseInt(req.params['slug'].split('-')[0], 10)
            return flyerService.getFlyerItem(itemId).then((item) => {
                if (!item) {
                    return next()
                }
                return Promise.all([
                    couponService.getCouponsForFlyerItem(itemId),
                    flyerService.getFlyer(item.flyerId),
                ]).then(([coupons, flyer]) => {
                    res.status = 200
                    metaTitleAndDescService.setItem(res, item, flyer)

                    if (
                        item.displayType === DisplayType.COUPONV2 ||
                        item.displayType === DisplayType.COUPONV3
                    ) {
                        /* If display type is COUPONV2 or COUPONV3, then we know this is the P&G BrandSaver so we
                         * actually want to display the Coupon pop instead of Item pop.
                         * Edge case: if no coupon matchup exists for this item, it means that that coupon is not
                         * available (clip limit, not in FSA) and we should show the Item pop with "not available"
                         * overlay */
                        if (coupons.length > 0) {
                            itemOrCouponDialog = makeCouponPop(coupons[0])
                        } else {
                            itemOrCouponDialog = makeItemPop(
                                item,
                                flyer,
                                coupons
                            )
                        }
                    } else {
                        itemOrCouponDialog = makeItemPop(item, flyer, coupons)
                    }

                    itemOrCouponDialog.addEventListener('close', back)
                    itemOrCouponDialog.addEventListener(
                        'flipp-navigate',
                        () => {
                            itemOrCouponDialog.removeEventListener(
                                'close',
                                back
                            )
                            itemOrCouponDialog.close()
                        }
                    )
                    itemOrCouponDialog.showModal()

                    if (item.displayType === DisplayType.VIDEO) {
                        analytics.trackFlyerItem(flyer, item.id, 11)
                    } else {
                        analytics.trackFlyerItem(flyer, item.id, 0)
                    }
                    appsflyerService.trackFlyerItem()
                })
            })
        }
    )

    .route(
        {
            from: 'item',
            to: 'browse',
        },
        (req, res) => {
            itemOrCouponDialog.removeEventListener('close', back)
            if (itemOrCouponDialog.open) itemOrCouponDialog.close()

            const flyerId = parseInt(req.params['slug'].split('-')[0], 10)

            return flyerService
                .getFlyer(flyerId, true, true)
                .then(async (flyer) => {
                    await metaTitleAndDescService.setListing(res, flyer)
                })
        }
    )

    .route(
        {
            from: 'search',
            to: 'browse',
        },
        async (req, res, next) => {
            const itemId = parseInt(req.params['slug'].split('-')[0], 10)
            const [item, coupons, flyer] = await modalService.getItemModalData(
                itemId,
                req,
                res,
                next
            )
            itemOrCouponDialog = modalService.makePop(item, coupons, flyer)
            itemOrCouponDialog.showModal()
        }
    )

    .route(
        {
            from: 'item',
            to: 'search',
        },
        (req) => {
            linkService.execute(`/search/${req.params.query}`, window)
            eventService.closePopupInSearch()
            window.removeEventListener('flipp-dialog-close', back)
        }
    )

    // Define the handlers
    .define('index', async (req, res) => {
        metaTitleAndDescService.setHomePage(res)
        const landingPageEntry = storageService.getItem('landing_page')
        let showLandingPage = true
        try {
            const entry = JSON.parse(landingPageEntry)
            const expired = !entry
                ? true
                : new Date().getTime() > Number(entry.expires_at)
            if (!entry || expired) {
                showLandingPage = true
            }
        } catch (e) {
            showLandingPage = true
        }

        if (showLandingPage) {
            const time = dateTimeService.getNow()
            storageService.setItem(
                'landing_page',
                JSON.stringify({
                    expires_at: time.plus({ months: 1 }).valueOf(),
                })
            )

            const bfService = BlackFridayService.getInstance()
            if (bfService.isOnHost() && bfService.isEnabled()) {
                const { render } = await import('./routes/blackfriday')
                return render(req, res)
            }

            res.redirect(linkService.linkTo('home'))
        } else {
            res.redirect(linkService.linkTo('listing'))
        }
    })

    .define('home', (req, res) => {
        renderHomePage(req, res)
    })

    .define('signin', (req, res) => {
        res.render(<SigninPage />)
    })

    .define('signup', (req, res) => {
        res.render(<SignupPage />)
    })

    .define('forgot_password', (req, res) => {
        res.render(<ForgotPasswordPage />)
    })

    .define('confirm_email', (req, res) => {
        res.render(<ConfirmEmailPage />)
    })

    .define('confirm_change_password', (req, res) => {
        res.render(<ConfirmChangePasswordPage />)
    })

    .define('change_password', (req, res) => {
        res.render(<ChangePasswordPage />)
    })

    .define('opt_in', (req, res) => {
        res.render(<OptInPage />)
    })

    .define('city_store', async (req, res) => {
        const store = req.params['store']
        if (req.url.pathname.includes('/store/')) {
            const link = req.url.pathname.replace('/store/', '/stores/')
            window.history.pushState({}, '', link)
        }
        res.render(
            <CityStorePage
                location={req.params['location']}
                store={store.toLowerCase()}
            />
        )
    })

    .define('stores', async (req, res) => {
        res.render(<StoresPage location={req.params['location']} />)
    })

    .define('listing', async (req, res, next: any) => {
        const bfService = BlackFridayService.getInstance()
        if (bfService.isOnHost() && bfService.isEnabled()) {
            const { render } = await import('./routes/blackfriday')
            return render(req, res)
        } else {
            const { default: route } = await import('./routes/listing')
            route(req, res, next)
        }
    })

    .define('browse', async (req, res) => {
        metadataService.setFlyerPageLink(req.params['slug'])
        // Return a promise since we need to get some data before responding
        const flyerId = parseInt(req.params['slug'].split('-')[0], 10)
        const itemId =
            'item_id' in req.params ? parseInt(req.params['item_id'], 10) : null
        const flyer = await flyerService.getFlyer(flyerId, true, true)
        if (!flyer) {
            const link = await expiredCanonicalsService.getFlyersLink()
            const redirectMessage = link.includes('/stores/')
                ? 'redirect_to_store_message'
                : link.includes('/weekly_ads')
                  ? 'redirect_to_flyers_message'
                  : 'redirect_item_message'
            return metadataService.redirectAsync(link, redirectMessage)
        }

        if (flyer) {
            metadataService.setUnavailableAfterTag(flyer.validTo)
        }

        await ExpiredMetadaService.getInstance().setFlyerData(flyerId)

        res.status = 200
        metaTitleAndDescService.setFlyer(res, flyer)

        // If req.sourceAction is not defined, that means that we DIRECTLY entered
        // the flyer URL into the browser as opposed to using <Link>.
        // Mark appropriately.
        // ----------------------------------------------------------------------
        const source =
            req.details && req.details.sourceAction
                ? req.details.sourceAction
                : SourceAction.Direct
        const flyerDetails =
            req.details && req.details.context ? req.details.context : null
        const merchant = flyer && flyer.merchant ? flyer.merchant : ''

        res.render(
            <FlyerPage
                merchant={merchant}
                flyerRunId={flyer.flyerRunId}
                flyerId={flyerId}
                sourceAction={source}
                itemId={itemId}
                flyerDetails={flyerDetails}
            />
        ).then(() => {
            if (flyerDetails) {
                // Fast flyer case - track flyer open immediately
                analytics.trackFlyerOpen(flyerDetails.flyer, source)
                appsflyerService.trackFlyerOpen()
                return
            }
            flyerService.getFlyer(flyerId).then((flyer) => {
                if (!flyer) {
                    analytics.trackPageNotFoundEvent()
                    return
                }
                FlyersViewedService.getInstance().count()
                analytics.trackFlyerOpen(flyer, source)
                appsflyerService.trackFlyerOpen()
            })
        })
    })

    .define('item', async (req, res, next) => {
        metadataService.setItemPageLink(req.params['slug'])
        // Return a promise since we need to get some data before responding
        const itemId = parseInt(req.params['slug'].split('-')[0], 10)
        const item = await flyerService.getFlyerItem(itemId)
        const flyer = item ? await flyerService.getFlyer(item.flyerId) : null
        if (!item || !flyer) {
            const link = await expiredCanonicalsService.getFlyersLink()
            const redirectMessage = link.includes('/stores/')
                ? 'redirect_to_store_message'
                : link.includes('/weekly_ads')
                  ? 'redirect_to_flyers_message'
                  : 'redirect_item_message'
            metadataService.redirectAsync(link, redirectMessage)
            return
        }
        metadataService.setUnavailableAfterTag(item.validTo)
        return Promise.all([
            couponService.getCouponsForFlyerItem(itemId),
            flyerService.getFlyer(item.flyerId),
        ]).then(([coupons, flyer]) => {
            if (!flyer) return next()

            res.status = 200
            metaTitleAndDescService.setItemPage(res, item)

            function forward() {
                // forward navigate
                linkService.execute(linkService.linkTo(flyer), window)
            }

            function displayItem() {
                if (
                    item.displayType === DisplayType.COUPONV2 ||
                    item.displayType === DisplayType.COUPONV3
                ) {
                    /* If display type is COUPONV2 or COUPONV3, then we know this is the P&G BrandSaver so we
                     * actually want to display the Coupon pop instead of Item pop.
                     * Edge case: if no coupon matchup exists for this item, it means that that coupon is not
                     * available (clip limit, not in FSA) and we should show the Item pop with "not available"
                     * overlay */
                    if (coupons.length > 0) {
                        itemOrCouponDialog = makeCouponPop(coupons[0])
                    } else {
                        itemOrCouponDialog = makeItemPop(item, flyer, coupons)
                    }
                } else {
                    itemOrCouponDialog = makeItemPop(item, flyer, coupons)
                }

                itemOrCouponDialog.addEventListener('close', forward)
                itemOrCouponDialog.addEventListener('flipp-navigate', () => {
                    itemOrCouponDialog.removeEventListener('close', forward)
                    itemOrCouponDialog.close()
                })
                itemOrCouponDialog.showModal()

                if (item.displayType === DisplayType.VIDEO) {
                    analytics.trackFlyerItem(flyer, item.id, 11)
                } else {
                    analytics.trackFlyerItem(flyer, item.id, 0)
                }
                appsflyerService.trackFlyerItem()
            }

            res.render(
                <FlyerPage
                    flyerId={item.flyerId}
                    flyerRunId={item.flyerRunId}
                    sourceAction={SourceAction.Direct}
                />
            ).then(() => {
                analytics.trackFlyerOpen(flyer, SourceAction.Direct)
                appsflyerService.trackFlyerOpen()
                displayItem()
            })
        })
    })

    .define('coupons', async (req, res, next) => {
        await metadataService.setCouponsPageLink()
        const userAgent = UserAgentService.getInstance()
        if (userAgent.mobile) {
            res.redirect(
                linkService.linkTo('install', {
                    feature: 'coupons',
                })
            )
            return
        }

        const category = req.params['category'] || 'all-deals'
        const categoryService = CategoryService.getInstance()
        const couponSlugToName = categoryService.getCouponsToSlugMapping()

        if (!(category in couponSlugToName)) {
            return next()
        }

        const categoryName = couponSlugToName[category]
        metaTitleAndDescService.setCoupons(req, res)

        Promise.all([
            res.render(<CouponsPageEntry category={categoryName} />),
            couponService.getCoupons(),
        ]).then(([, coupons]) => {
            const filteredCoupons = coupons.filter((coupon) =>
                array.contains(coupon.categories, categoryName)
            )

            const sortOrder: string = 'all'
            analytics.trackCouponListing(
                categoryName,
                filteredCoupons,
                sortOrder
            )
        })
    })

    .define('coupon', async (req, res) => {
        metadataService.setCouponPageLink(req.params['slug'])
        const couponId = parseInt(req.params['slug'].split('-')[0], 10)
        const coupon = await couponService.getCoupon(couponId)
        if (!coupon) {
            const link = expiredCanonicalsService.getCouponsLink()
            metadataService.setCanonicalAsync(link)
            await ExpiredMetadaService.getInstance().setCouponData(
                req.params['slug'],
                couponId
            )

            return metadataService.redirectAsync(
                link,
                'redirect_coupon_message'
            )
        }

        metadataService.setUnavailableAfterTag(coupon.validTo)
        setCouponTitleAndDescription(coupon, res)

        res.render(<CouponsPageEntry category={req.params['category']} />).then(
            () => {
                itemOrCouponDialog = makeCouponPop(coupon)
                itemOrCouponDialog.showModal()
                analytics.trackCoupon(
                    coupon,
                    CouponActions.Open,
                    CouponSource.CouponListing
                )

                itemOrCouponDialog.addEventListener('close', () => {
                    if (req.params.locale && req.params.city) {
                        linkService.execute(
                            `/${req.params.locale}/${req.params.city}/coupons`,
                            window
                        )
                    } else {
                        itemOrCouponDialog.addEventListener(
                            'close',
                            couponCloseForward
                        )
                    }
                })
                itemOrCouponDialog.addEventListener('flipp-navigate', () => {
                    itemOrCouponDialog.removeEventListener('close', back)
                    itemOrCouponDialog.removeEventListener(
                        'close',
                        couponCloseForward
                    )
                    itemOrCouponDialog.close()
                })
            }
        )
    })

    .define('clippings', (req, res) => {
        res.redirect(linkService.linkTo('shopping_list'))
    })

    .define('shoppinglist', (req, res) => {
        metaTitleAndDescService.setShoppingList(res)
        res.render(<ShoppingListEntry />)
    })

    .define('favourites', (req, res) => {
        metaTitleAndDescService.setFavourites(res)
        Promise.all([
            res.render(<FavouritesPage />),
            flyerService.getFlyers(),
        ]).then(([, flyers]) => {
            return favourites
                .getFavouriteMerchantIds(null)
                .then((favMerchants) => {
                    const categoryName: string = 'favorites'
                    const sortOrder: string = 'favorites'
                    analytics.trackFlyerListing(
                        categoryName,
                        flyers,
                        sortOrder,
                        favMerchants
                    )
                })
        })
    })

    .define('data-deletion', (req, res) => {
        res.render(<ListingPage />).then(() => {
            renderDeleteAccountModal('flyers')
        })
    })

    .define('install', async (req, res) => {
        const { default: route } = await import('./routes/install')
        route(req, res)
    })

    .define('search', (req, res) => {
        const q = req.params['query'] || req.params['q']
        if (!q) {
            res.render(<ErrorPage page={true} isWatchList={'false'} />).then(
                () => {
                    analytics.trackPageNotFoundEvent()
                }
            )
            return
        }
        const sort = req.params['sort'] || 'all'

        metaTitleAndDescService.setSearch(req, res)

        Promise.all([
            res.render(<SearchPage query={q} sort={sort} />),
            searchService.getSearchResult(q),
        ]).then(([, [flyers, items, coupons, ecomItems]]) => {
            const numFlyers = flyers.filter(
                (flyer) => !flyer.isTombstone
            ).length
            const tombstoneCount = flyers.length - numFlyers
            const couponMatchupsCounts = coupons
                .filter((coupon) => Boolean(coupon))
                .map((coupon) => coupon.matchUps.length)
            const couponMatchupCount =
                couponMatchupsCounts.length === 0
                    ? 0
                    : couponMatchupsCounts.reduce(
                          (prev, current) => prev + current
                      )
            const numEcomItems = Array.isArray(ecomItems) ? ecomItems.length : 0

            analytics.trackSearch(
                q,
                numFlyers,
                tombstoneCount,
                items.length,
                numEcomItems,
                coupons.length,
                couponMatchupCount,
                'global'
            )
        })
    })

    .define('distribution', (req, res) => {
        const flyerId = req.params['flyer_id']
            ? parseInt(req.params['flyer_id'], 10)
            : null
        const flyerRunId = req.params['flyer_run_id']
            ? parseInt(req.params['flyer_run_id'], 10)
            : null
        const merchantId = req.params['merchant_id']
            ? parseInt(req.params['merchant_id'], 10)
            : null
        res.render(
            <NativeLanding
                flyerId={flyerId}
                flyerRunId={flyerRunId}
                merchantId={merchantId}
            />
        )
    })

    .define('flyers-country', (req, res) => {
        res.render(<FlyersCountry />)
    })

    .define('store-city-flyers', (req, res) => {
        res.render(<StoreCityFlyers />)
    })

    .define('appstore', () => {
        window.location.href = userAgentService.iosAppLink()
    })

    .define('playstore', () => {
        window.location.href =
            userAgentService.getAndroidAppLink('playstore_redirect')
    })
    .define('country_homepage', async (req, res) => {
        renderHomePage(req, res)
        return
    })
    .define('city_homepage', (req, res) => {
        metadataService.setAmpLink(req.path)
        metaTitleAndDescService.setCityHomePage(res)
        res.render(<CityHomepage />)
    })
    .define('states_browser', async (req) => {
        window.location.href = `/${req.params['locale']}/flyers`
    })
    .define('cities_browser', async (req) => {
        window.location.href = `/${req.params['locale']}/flyers`
    })
    .define('ccpa_form', (req, res) => {
        res.render(<CCPAForm />)
    })
    .define('ccpa_form_success', (req, res) => {
        res.render(<CCPAFormSuccess />)
    })

    .define('categories', async (req) => {
        let url = req.params['locale'] ? `${req.params['locale']}` : ''
        if (req.params['state'] && req.params['city']) {
            url = `${url}/${req.params['city']}-${req.params['state']}`
        }
        window.location.href = `${url}/flyers`
    })
    .define('sub_categories', async (req) => {
        let url = req.params['locale']
            ? `${req.params['locale']}/search`
            : '/search'
        if (req.params['state'] && req.params['city']) {
            url = `${url}/${req.params['city']}-${req.params['state']}`
        }
        const product = req.params['category'].split('-')[0]
        window.location.href = `${url}/${product}`
    })
    .define('categories_products', async (req) => {
        let url = req.params['locale']
            ? `${req.params['locale']}/search`
            : '/search'
        if (req.params['state'] && req.params['city']) {
            url = `${url}/${req.params['city']}-${req.params['state']}`
        }
        const product = req.params['sub_category'].split('-')[0]
        window.location.href = `${url}/${product}`
    })
    .define('products', async (req) => {
        const url = req.params['locale']
            ? `${req.params['locale']}/search`
            : '/search'
        const product = req.params['product_name']
        window.location.href = `${url}/${product}`
    })
    .define('blackfriday', async (req, res) => {
        const { default: route } = await import('./routes/blackfriday')
        route(req, res)
    })

function setCouponTitleAndDescription(coupon: Coupon, res: Response) {
    metaTitleAndDescService.setCouponRouting(res, coupon)
}

function renderHomePage(req: Request, res: Response) {
    const city = locationService.city
    metaTitleAndDescService.setHomePage(res)
    res.render(<NewLandingPage cityName={city} />)
    metadataService.setAmpLink(req.path)
}

function dispatchFlyerOpen(req: Request, res: Response) {
    /* Normalize the query parameters */
    function readIds(name: string) {
        return req.params[name]
            ? req.params[name].split(',').map((id) => parseInt(id, 10))
            : null
    }

    const flyer_ids = readIds('flyer_ids')
    const flyer_run_ids = readIds('flyer_run_ids')
    const list_flyer_run_ids = readIds('list_flyer_run_ids')
    const flyer_type_ids = readIds('flyer_type_ids')
    const merchant_ids = readIds('merchant_ids')
    const item_ids = readIds('item_ids')

    if (
        !flyer_ids &&
        !flyer_run_ids &&
        !flyer_type_ids &&
        !merchant_ids &&
        !list_flyer_run_ids
    ) {
        /* Route directly to '/flyers' in the case where no parameters are provided */
        res.redirect(linkService.linkTo('listing'))
        return
    }

    res.render(
        <ActionLanding
            flyerIds={flyer_ids}
            itemIds={item_ids}
            flyerRunIds={flyer_run_ids}
            listFlyerRunIds={list_flyer_run_ids}
            flyerTypeIds={flyer_type_ids}
            merchantIds={merchant_ids}
        />
    )
}

function dispatchShoppingList(req: Request, res: Response) {
    res.redirect('/shopping_list')
    return
}

function dispatchCouponsListing(req: Request, res: Response) {
    res.redirect(linkService.linkTo('coupons'))
    return
}

async function dispatchFlyerListing(req: Request, res: Response) {
    const categoryService = CategoryService.getInstance()
    const categories = categoryService.getCategorySlugToNameMapping()
    const param = req.params['category']
    if (param) {
        if (param.toLowerCase() === 'favorites') {
            res.redirect(linkService.linkTo('favourites'))
        } else if (
            param === categories[ConfigService.getInstance().BF_CATEGORY]
        ) {
            const category = await categoryService.clarifyBlackFridayCategory()
            return BlackFridayService.getInstance().redirectToHost(category)
        } else if (param === categories['fathers-day']) {
            const category = new FlyerCategory(categories['proudly-canadian'])
            res.redirect(linkService.linkTo(category))
        } else if (param.toLowerCase() === 'latest') {
            res.redirect(linkService.linkTo('listing?sort=latest'))
        } else {
            let category = new FlyerCategory(param)
            if (category.name === 'Boxing Day') {
                category = new FlyerCategory('Boxing Week')
            }
            const currentSearchParams = new URLSearchParams(
                window.location.search
            )
            let qp
            if (currentSearchParams.has('forceBoxingWeek')) {
                qp = { forceBoxingWeek: true }
            }
            res.redirect(linkService.linkTo(category, qp))
        }
    } else if (req.params['command'] === 'query') {
        res.redirect(linkService.linkTo('search', { q: req.params['text'] }))
    } else {
        res.redirect(linkService.linkTo('listing'))
    }

    return
}

function dispatchBrandmediaLanding(req: Request) {
    const param = req.params['url']
    if (!param) {
        return
    }

    // Verify that we're on flipp.com
    const a = document.createElement('a')
    a.href = param

    const hostname = a.hostname
    const parts = hostname.split('.')

    if (parts.slice(-1)[0] !== 'com' || parts.slice(-2)[0] !== 'flipp') {
        return
    }

    // OK we're on flipp.com - go there
    // Example url - https://brandmedia-stg.flipp.com/page/sKY869d23eg.html
    window.location.href = param

    return
}
